import SearchBar from "./searchbar";

export const search = {
  init: (searchbarOpenButtons) => {
    const searchbars = document.querySelectorAll(".sd-searchbar");
    [...searchbars].forEach((searchbarItem) => new SearchBar(searchbarItem, searchbarOpenButtons));
  },
};

export default search;